import Modal from 'react-modal'

import coupler from 'utils/coupler'
import { maxValue } from 'utils/data'
import withRouter from 'utils/withRouter'

import handlers, { initialState } from 'handlers/dashboard'

import ChartCard from 'components/ChartCard'
import Filter from 'components/Filter'
import GAProfiles from 'components/GAProfiles'
import LineChart from 'components/LineChart'
import Loader from 'atoms/Loader'
import PieList from 'components/PieList'

import { modal } from 'styles'

const hasData = p => p.changes.length || p.mrr.length || p.users.length

function render() {
  const {
    handle,
    state,
    props: { changes, gaProfiles, mrr, tasks, users, ...props }
  } = this
  return (
    <div className='container page column'>
      <Filter
        onChange={e => props.setChartDate(e.target.value)}
        value={props.chartDate} />
      <div className='center' style={{ display: 'flex', flexDirection: 'column', height: '45em', justifyContent: 'space-between', width: '100%' }}>
        <div style={{ display: 'flex', height: '20em', width: '100%' }}>
          { mrr.status === 'loading'
            ? <div className='center full column'><Loader /></div>
            : <ChartCard service='stripe' hasService={mrr.status === 'succeeded'} data={mrr.state} />
          }
          { users.status === 'loading'
            ? <div className='center full column'><Loader /></div>
            : <ChartCard service='google' hasService={users.status === 'succeeded'} data={users.state} />
          }
        </div>
        <div style={{ display: 'flex', height: '20em', width: '100%' }}>
          { tasks.status === 'loading'
            ? <div className='center full column'><Loader /></div>
            : <ChartCard service='jira' hasService={tasks.status === 'succeeded'} data={tasks.state} />
          }
          { changes.status === 'loading'
            ? <div className='center full column'><Loader /></div>
            : <ChartCard service='github' hasService={changes.status === 'succeeded'} data={changes.state} />
          }
        </div>
      </div>
      <div style={{ display: 'flex', height: '27em', margin: '1em 0', width: '100%' }}>
        { hasData({ changes, mrr: mrr.state, users: users.state }) &&
          <PieList {...props} onClick={handle.tab} selected={state.tab} />
        }
        <div className='multichart'>
          { hasData({ changes: changes.state, mrr: mrr.state, users: users.state })
            ? 
            <div className='full column'>
              <div className='chart-header'>Stripe, Jira, Google Analytics, GitHub</div>
              <LineChart
                data={[
                  { id: 'stripe', data: mrr.state },
                  { id: 'jira', data: tasks.state },
                  { id: 'google', data: users.state },
                  { id: 'github', data: changes.state.map(x =>
                    ({ x: x.date, y: x.additions + x.deletions })
                  ) }
                ]}
                max={maxValue(changes.state, mrr.state, users.state, tasks.state)}
              />
            </div>
            : 'You have no data' }
        </div>
      </div>
      <Modal style={modal}
        isOpen={gaProfiles.length > 0 && users.status === 'failed'}
        onRequestClose={handle.modal}>
        <GAProfiles {...{ gaProfiles }} onClick={handle.click} />
      </Modal>
    </div>
  )
}

export default withRouter(coupler(
  { handlers, initialState, render },
  [
    'changes',
    'chartDate',
    'contributions',
    'events',
    'gaProfiles',
    'mrr',
    'pages',
    'sources',
    'tasks',
    'users'
  ],
  [
    'connectGitHub',
    'connectGoogle',
    'connectJira',
    'connectStripe',
    'getChanges',
    'getContributions',
    'getEvents',
    'getMRR',
    'getPages',
    'getSources',
    'getTasks',
    'getUsers',
    'setChartDate',
    'setProfile'
  ]
))